import React, { Fragment, useEffect, useState } from 'react';
import { useScroll } from 'react-use';
import { defaultSwipeableConfig } from './Swipeable.globals';
import { SwipeableButton } from './SwipeableButton';
import { useMeasure } from '../../../../play-core/hooks/use-measure';
import { useHorizontalScrollTracker } from '../../analytics/useHorizontalScrollTracker';
import { useMediaQuery } from '../../hooks/use-media-query';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const scrollWidthFactor = 0.9;
const scrollRightBy = (ref, amount) => {
  ref.current?.scrollBy({
    top: 0,
    left: amount,
    behavior: 'smooth'
  });
};
export const SwipeableButtons = ({
  swipeableItemCount,
  positionFactor,
  config,
  swipeableRef,
  scrollRef,
  analyticsTitle
}) => {
  const [wasUsed, setUsed] = useState(false);
  const {
    x: scrollPosition
  } = useScroll(scrollRef);
  const [scrollWidth, setScrollWidth] = useState(0);
  const [swipeableWidth, setSwipeableWidth] = useState(0);
  const swipeableSize = useMeasure(swipeableRef);
  useHorizontalScrollTracker(analyticsTitle, scrollPosition, swipeableWidth, scrollWidth);

  // Update the scroll width when the size of the scroll container
  // or the number of items in the swipeable changes.
  useEffect(() => {
    setTimeout(() => {
      if (scrollRef.current) {
        setScrollWidth(scrollRef.current.scrollWidth);
      }
      if (swipeableRef.current) {
        setSwipeableWidth(swipeableRef.current.getBoundingClientRect().width);
      }
    }, 100);
  }, [scrollRef, swipeableRef, swipeableItemCount, swipeableSize]);
  const {
    spaceBetween,
    spaceBefore,
    itemCount
  } = useMediaQuery(config, defaultSwipeableConfig);
  const itemWidth = Math.max((swipeableWidth - itemCount * spaceBetween - spaceBefore) / itemCount, 0);
  const scrollDistance = (itemWidth + spaceBetween) * Math.floor(itemCount) * scrollWidthFactor;
  const scrollOffset = 5;
  const canScroll = scrollWidth > swipeableWidth + scrollOffset;
  const canGoLeft = scrollPosition > scrollOffset;
  const canGoRight = scrollWidth - scrollOffset > scrollPosition + swipeableWidth;
  const top = positionFactor ? itemWidth * positionFactor / 2 : undefined;
  useEffect(() => {
    if (canGoLeft) {
      setUsed(true);
    }
  }, [canGoLeft]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [wasUsed && /*#__PURE__*/_jsx(SwipeableButton, {
      direction: "left",
      onClick: () => {
        scrollRightBy(scrollRef, -scrollDistance);
        setUsed(true);
      },
      spacing: 24,
      top: top,
      isActive: canGoLeft
    }), canScroll && /*#__PURE__*/_jsx(SwipeableButton, {
      direction: "right",
      onClick: () => {
        scrollRightBy(scrollRef, scrollDistance);
        setUsed(true);
      },
      spacing: 24,
      top: top,
      isActive: canGoRight
    })]
  });
};